import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'


class ProductManagerDependentController {
    constructor() {
        basicController(this)
        const $ctrl = this;
    }
    $onInit() {
        const $ctrl = this;
        $ctrl.designId = $ctrl.manager.designId;
        $ctrl.query = $ctrl.manager.query;
        $ctrl.navs = $ctrl.manager.navs;
    }
}

export default ProductManagerDependentController;